module.exports = __webpack_public_path__ + "img/word_2x.744bc968.svg";